export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12140.31f15efd.jpg";